/* Code for accessibility */
import $ from 'jquery';

$(document).ready(function() {
    setTimeout(function(){
        if(window.innerWidth<=900){
            $( "<div class='button-show-hide'>Hide</div><div class='ind-wrap-show-hide'></div>" ).insertAfter( "#INDmenu-btn" );

            $('.button-show-hide').on("click", function (event) {
                if($('#INDbtnWrap').hasClass("stop_animation"))
                {
                    $('#INDbtnWrap').removeClass("stop_animation");
                }
                else
                {
                    $('#INDbtnWrap').addClass("stop_animation");
                }
            });
            $('.ind-wrap-show-hide').on("click", function (event) {
                if($('#INDbtnWrap').hasClass("stop_animation"))
                {
                    $('#INDbtnWrap').removeClass("stop_animation");
                }
                else
                {
                    $('#INDbtnWrap').addClass("stop_animation");
                }
                setTimeout(function(){
                    $('#INDbtnWrap').removeClass("stop_animation");
                },4000);
            });
        }else{

            $( "<div class='button-show-hide'>Unhide</div>" ).insertAfter( "#INDmenu-btn" );
            $("#INDbtnWrap").addClass("userway_hidden" );

            $('.button-show-hide').on("click", function (event) {
                if($('#INDbtnWrap').hasClass("stop_animation"))
                {
                    $('#INDbtnWrap').removeClass("stop_animation");
                    $('.button-show-hide').text('Unhide');
                    $("#INDbtnWrap").removeClass("uo" );
                }
                else
                {
                    $('.button-show-hide').text('Hide');
                    $('#INDbtnWrap').addClass("stop_animation");
                }
            });

            $("#INDbtnWrap").hover(
                function () {
                    $(this).addClass("uo");
                },
                function () {
                    $(this).removeClass("uo");
                }
            );

        }

    },5000);
});
